<div *ngIf="showSideNavigation" class="mc-side-area">
  <mc-app-side-area-links [navItems]="permittedNavItems" [currentModule]="currentModule"> </mc-app-side-area-links>
</div>
